import * as ISchema from "#webapp/src/__schema__";
import { User } from "@clockwise/schema";
import { DateTime } from "luxon";
export const daysSinceUserCreation = (user: ISchema.IUser | User) => {
  const createdDateTime = DateTime.fromMillis(user.createdTime);
  const now = DateTime.local();

  const timeSinceCreation = now.diff(createdDateTime, ["days"]);
  return Math.ceil(timeSinceCreation.days);
};

export const getIsNewUser = (user: ISchema.IUser | User) => {
  if (!user.createdTime) {
    return false;
  }
  return daysSinceUserCreation(user) <= 30;
};
